/* 
PROTECTED PAGE 
*/
import React from "react";
import SendMessages from "../../Components/SendMessages/SendMessages";
import Layout from "../../Components/Layout/Layout";

function MessagesPage() {
  return (
    <Layout>
      <SendMessages />
    </Layout>
  );
}

export default MessagesPage;
